export class EIRDropdownFilterConfig {
  static readonly configs = [
    {
      annotation: 'metadata.title',
      label: 'Service/API',
    },
    {
      annotation: 'metadata.annotations.backstage.io/serviceOwner',
      label: 'Service Owner',
    },
    {
      annotation: 'metadata.annotations.backstage.io/enforcesEntitlements',
      label: 'Enforces Entitlements',
    },
    {
      annotation: 'spec.owner',
      label: 'Team',
    },
    // EIR Compliance filters — each maps to the `compliant` field of the rule
    {
      annotation: 'spec.entitlementIntegrationRules.assetConditionEnforcement.compliant',
      label: 'Asset Condition Enforcement',
    },
    {
      annotation: 'spec.entitlementIntegrationRules.clientTypeAgnosticCompliance.compliant',
      label: 'Client Type Agnostic Compliance',
    },
    {
      annotation: 'spec.entitlementIntegrationRules.commonLibraryStandardization.compliant',
      label: 'Common Library Standardization',
    },
    {
      annotation: 'spec.entitlementIntegrationRules.dynamicRuleExternalization.compliant',
      label: 'Dynamic Rule Externalization',
    },
    {
      annotation: 'spec.entitlementIntegrationRules.corpExperienceFlagResilience.compliant',
      label: 'Corp Experience Flag Resilience',
    },
    {
      annotation: 'spec.entitlementIntegrationRules.entitlementsContractCompliance.compliant',
      label: 'Entitlements Contract Compliance',
    },
    {
      annotation: 'spec.entitlementIntegrationRules.filterConditionEnforcement.compliant',
      label: 'Filter Condition Enforcement',
    },
    {
      annotation: 'spec.entitlementIntegrationRules.newAttributeTolerance.compliant',
      label: 'New Attribute Tolerance',
    },
    {
      annotation: 'spec.entitlementIntegrationRules.sessionCacheKeyStandard.compliant',
      label: 'Session Cache Key Standard',
    },
    {
      annotation: 'spec.entitlementIntegrationRules.standardInternalAccessControlImplementation.compliant',
      label: 'Standard Internal Access Control',
    },
    {
      annotation: 'spec.entitlementIntegrationRules.tokenDecodingRestriction.compliant',
      label: 'Token Decoding Restriction',
    },
  ];
}
